import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/attention_blue.svg'
import _imports_1 from '@/assets/img/f_green.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-b937770a")

_pushScopeId("data-v-b937770a")
const _hoisted_1 = { class: "flex_spacebetween column h-100 uncompletedProfile" }
const _hoisted_2 = { class: "text-center flex_centered column page_padding" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "mb-2",
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "card_container" }
const _hoisted_5 = { class: "bg_blue flex_spacebetween_centered column" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = { class: "bg_blue flex_spacebetween_centered column" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_9 = { class: "bg_blue flex_spacebetween_centered column" }
const _hoisted_10 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_11 = { class: "bg_blue flex_spacebetween_centered column" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_13 = { class: "page_padding" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_localized_text = _resolveComponent("localized-text")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isExperiencePage)
        ? (_openBlock(), _createBlock(_component_localized_text, {
            key: 0,
            localizedKey: "app_Ciao{{name}}PerVisualizzareLeExperienceDeviPrimaCompletareIlTuoProfilo",
            text: "Ciao {{name}}, per visualizzare le experience devi prima completare il tuo profilo!",
            object: { name: _ctx.$store.state.loggedUser.completeName },
            class: "fev_text5 fw_700"
          }, null, 8, ["object"]))
        : (_openBlock(), _createBlock(_component_localized_text, {
            key: 1,
            localizedKey: "app_Ciao{{name}}PerVisualizzareGliAltriProfiliDeviPrimaCompletareIlTuo",
            text: "Ciao {{name}}, per visualizzare gli altri profili devi prima completare il tuo!",
            object: { name: _ctx.$store.state.loggedUser.completeName },
            class: "fev_text5 fw_700"
          }, null, 8, ["object"]))
    ]),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_localized_text, {
          localizedKey: "app_1ScegliLe{{minimumQuestionsNumber}}Foto",
          text: "1. <br /> Scegli le {{minimumQuestionsNumber}} foto",
          object: { minimumQuestionsNumber: _ctx.minimumRequiredQuestionsNumber },
          class: "fev_text2 fw_800"
        }, null, 8, ["object"])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_localized_text, {
          localizedKey: "app_2Crea{{minimumQuestionsNumber}}DomandeE4RispostePerOgniFoto",
          text: "2. <br /> Crea {{minimumQuestionsNumber}} domande e 4 risposte per ogni foto",
          object: { minimumQuestionsNumber: _ctx.minimumRequiredQuestionsNumber },
          class: "fev_text2 fw_800"
        }, null, 8, ["object"])
      ]),
      _createVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_localized_text, {
          localizedKey: "app_3ImpostaIlTuoAffinityRate",
          text: "3. <br /> Imposta il tuo Affinity Rate",
          class: "fev_text2 fw_800"
        })
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_localized_text, {
          localizedKey: "app_4SeVuoiCompletaIlTuoProfiloConUnaBio",
          text: "4. <br /> Se vuoi completa il tuo profilo con una Bio",
          class: "fev_text2 fw_800"
        })
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode("button", {
        class: "fev_button big bg_brand",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/profile')))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "app_Completa",
          text: "Completa"
        })
      ])
    ])
  ]))
})